/**
 * Which parts of the product actually exist yet.
 *
 * Anshul's 2026-09-06 standing rule: the demo must look finished, and a control whose phase
 * has not landed is NOT RENDERED - never rendered inert, never rendered pointing at a route
 * that does not exist. An inert or dead control reads as a broken product during a demo,
 * which is worse than an absent one.
 *
 * That rule was being broken in five places at once, all with the same failure: buttons and
 * nav items pointing at `/projects/:id/videos`, `/review`, `/reports` and `/admin/metrics`,
 * none of which have a route in App.js. React Router has no wildcard on those parents, so
 * every click fell through to the catch-all and silently returned the user to the GLOBAL
 * dashboard - no error, no toast, nothing to explain why "Review" had just navigated
 * somewhere else entirely.
 *
 * Keeping the flags here rather than inline at each call site means a phase turns its feature
 * on by flipping ONE boolean, instead of grepping for every link that should light up - which
 * is the mistake that produced the dead controls in the first place.
 *
 * When a phase lands its route in App.js, flip its flag in the same commit.
 */

export const FEATURES = {
  /** P6: project videos list and the upload flow. Route: /projects/:projectId/videos */
  projectVideos: true,

  /** P7, rebuilt in V8: a video's Review Queue tab. Route: /projects/:projectId/videos/:videoId/review */
  projectReview: true,

  /** P7, rebuilt in V8: a video's Report tab. Route: /projects/:projectId/videos/:videoId/report */
  projectReports: true,

  /** P8: the admin metrics and logs board. Route: /admin/metrics */
  adminMetrics: true,
};

export default FEATURES;
